import { useEffect, useState } from 'react';

/**
 * iOS 스타일 원형 바 스피너 + 중앙 로딩 경과 시간 표시
 */
function PageSpinner() {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const bars = 12;

  return (
    <div className="page-spinner-wrapper">
      <div className="page-spinner">
        {Array.from({ length: bars }, (_, i) => (
          <div
            key={i}
            className="page-spinner-dot"
            style={{
              transform: `rotate(${i * 30}deg)`,
              animationDelay: `${-((bars - i) / bars) * 1.2}s`,
            }}
          />
        ))}
        <span className="page-spinner-elapsed">{elapsed}s</span>
      </div>
    </div>
  );
}

export default PageSpinner;
